import { render } from "./LocationOverview.vue?vue&type=template&id=68b243ba"
import script from "./LocationOverview.vue?vue&type=script&lang=js"
export * from "./LocationOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__